import React, { useEffect } from 'react';

const plaidStylesheetId = 'plaid-link-stylesheet';
const plaidIdPrefix = 'plaid-link-iframe';

export const usePlaidStyleOverride = (hidePlaid: boolean) => {
  useEffect(() => {
    const togglePlaidStyles = () => {
      const plaidStylesheet: HTMLStyleElement | null = document.querySelector(
        `style#${plaidStylesheetId}`
      );

      if (plaidStylesheet) {
        plaidStylesheet.media = hidePlaid ? 'max-width: 0px' : '';
      }
    };

    togglePlaidStyles();

    const observer = new MutationObserver(mutations => {
      const didAddStyles = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(
          node => node instanceof Element && node.id === plaidStylesheetId
        )
      );

      if (didAddStyles) {
        togglePlaidStyles();
      }
    });

    observer.observe(document.head, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, [hidePlaid]);

  return hidePlaid ? (
    <style>{`
        [id^="${plaidIdPrefix}"] {
            visibility: hidden !important;
        }
    `}</style>
  ) : null;
};
